import React from 'react';
import { Box, Drawer, ListItem, Typography, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Link } from 'react-scroll';
import landUrl from '../resource/land.svg';




const useStyles = makeStyles((theme) => ({
    drawer: {
        width: '100%',
        flexShrink: 0,
        position: 'absolute',
        zIndex: 1000,

    },
    drawerPaper: {
        width: '100%',
        backgroundImage: `url(${landUrl})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        color: 'white',
        opacity: '95%'
    },
    drawerPaperAlternate: {
        width: '100%',
        color: 'white',
    },
    drawerHeader: {
        ...theme.mixins.toolbar,
    },
}));

const items = [
    { name: 'HOME', to: 'home' },
    { name: 'LIS', to: 'lis' },
    { name: 'MIDDLEWARE', to: 'middleware' },
    { name: 'NOSOTROS', to: 'about' },
    { name: 'CONTACTO', to: 'contact' },

];

const Menu = ({ open, onClickMenu }) => {

    const classes = useStyles();


    return (
        <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="left"
            open={open}
            classes={{
                paper: classes.drawerPaper
            }}>

            <div className={classes.drawerHeader} />

            {
                items.map(item =>

                    <ListItem onClick={() => onClickMenu(item.to)}>

                        <div >
                            <Typography
                                variant="h6"
                                style={{ width: '100%', padding: '1em' }}
                                align='left'
                                color="secondary">
                                <Box fontWeight={900} >{item.name}</Box>
                            </Typography>
                        </div>
                    </ListItem>)

            }


        </Drawer >
    );
};

export default Menu;

